import React, { useEffect, useState } from "react";
import {
  Button,
  Row,
  Col,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { fetchClasses } from "../../actions/classActions";
import CreateStudent from "../Teacher/CreateStudent";
import StudentTable from "../../components/Tables/StudentTable";
import { FormattedMessage } from "react-intl";
import EditStudent from "../../components/Modal/EditStudent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector, useDispatch } from "react-redux";

function AdminStudents(props) {
  const [filterSearch, setFilterSearch] = useState("");
  const [students, setStudents] = useState([]);
  const [studentEditModal, setStudentEditModal] = useState(false);
  const [school] = useState(
    props.location.state
      ? props.location.state.school
      : JSON.parse(localStorage.getItem("school")),
  );
  const [displayCreateStudentModal, setDisplayCreateStudentModal] =
    useState(false);
  const [studentToUpdate, setStudentToUpdate] = useState(null);

  const dispatch = useDispatch();

  const classesReducer = useSelector((state) => state.classReducer);

  useEffect(() => {
    localStorage.setItem("school", JSON.stringify(school));
    dispatch(fetchClasses(school.id));
  }, [school, dispatch]);

  useEffect(() => {
    if (!classesReducer.loading) {
      var tempStudents = [];
      classesReducer.result.forEach((c) => {
        c.students.forEach((s) => {
          tempStudents.push(s);
        });
      });
      setStudents(tempStudents);
    }
  }, [classesReducer]);

  const toggleStudentEditModal = (student) => {
    setStudentToUpdate(null);

    if (student && student.hasOwnProperty("email")) {
      setStudentToUpdate(student);
    }
    setStudentEditModal(!studentEditModal);
  };

  const updateStudents = () => {
    var tempStudents = [];
    dispatch(fetchClasses(school.id)).then(() => {
      classesReducer.result.forEach((c) => {
        c.students.forEach((s) => {
          tempStudents.push(s);
        });
      });
      setStudents(tempStudents);
    });
  };

  const handleFilterSearch = (event) => {
    setFilterSearch(event.target.value);
  };

  const toggleCreateStudentModal = () => {
    setDisplayCreateStudentModal(!displayCreateStudentModal);
  };

  const updateClassesAndStudents = () => {
    setDisplayCreateStudentModal(false);
    updateStudents();
  };

  return (
    <div>
      <div className="card card-body">
        <h5 className="no-margin">Elever {school.name}</h5>
      </div>
      <div className="container-fluid admin-container">
        <Col>
          <Row className="search-row">
            <Col className="col-3">
              <Input
                placeholder="Sök elever"
                onChange={(data) => handleFilterSearch(data)}
              />
            </Col>
            <Col className="col-9">
              <Button
                color="primary"
                outline
                className="float-end"
                onClick={() => toggleCreateStudentModal()}
              >
                <FontAwesomeIcon icon="plus" />
              </Button>
            </Col>
          </Row>
          <StudentTable
            filter={filterSearch}
            toggleEdit={toggleStudentEditModal}
            showClass={true}
            students={students}
          />
        </Col>
      </div>

      <Modal
        size="lg"
        isOpen={displayCreateStudentModal}
        toggle={toggleCreateStudentModal}
      >
        <ModalHeader toggle={toggleCreateStudentModal}>
          <FormattedMessage id="Views.Teacher.Students.Modal.AddNewStudent" />
        </ModalHeader>
        <ModalBody>
          <CreateStudent
            classes={classesReducer.result}
            updateStudents={updateClassesAndStudents}
            dismissModal={toggleCreateStudentModal}
          />
        </ModalBody>
      </Modal>

      <EditStudent
        toggle={toggleStudentEditModal}
        isOpen={studentEditModal}
        student={studentToUpdate}
        updateStudents={updateStudents}
        classes={classesReducer.result}
      />
    </div>
  );
}

export default AdminStudents;
